import { http } from "Utils/http";
import { Form, Col, Row, Spinner, Button } from 'react-bootstrap';
import {TextButton, IconTextButton, IconButton} from 'Components/Button';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import {store} from 'Store';
import { useState, useEffect,useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import {useParams, useLocation, useNavigate } from 'react-router-dom';
import { formatDate, isInObject } from "Utils/utilityFunctions";
import DatatableDropdownEntryField from "Components/Datatable/DatatableComponents/DatatableDropdownEntryField";
import DatatableDropdownCheckboxesField from "Components/Datatable/DatatableComponents/DatatableDropdownCheckboxesField";
import { FilterDrama } from "@mui/icons-material";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from "Utils/constants";
import { httpDownload } from "Utils/httpDownload";
import Download from '@mui/icons-material/FileDownloadOutlined';
import { ICONS } from "Utils/icons";




const PSOCFSubmissionSummaryTable = ({ ...props}) => {
    // Date format: mm/dd/yyyy hh: mm
    const loginInfo = useSelector(state => state.loginInfo);
    //console.log(loginInfo);

    let location = useLocation();
    
    const navigate = useNavigate();
    
    const dispatch = useDispatch();
  

    const [sortColumn, setSortColumn] = useState({
        sortField: "psoId",
        sortDirection: "asc"
    });

    const [filter, setFilter] = useState(null);
    const [docFilter, setDocFilter] = useState(null);
  
    useEffect(()=>{
        var passedData = location.state;
        
        if(isInObject("filter",passedData)) {
            //console.log("setFilter");
            //console.log(passedData.filter);
            setFilter(passedData.filter);
        }
        else {
            setFilter({
                startIndex:0,
                entryPerPage:10,
                sortingColumn:sortColumn.sortField,
                sortingOrder:sortColumn.sortDirection,
                searchTerm:""
            });
        }
        //console.log(filter);
        //console.log(docFilter);
    },[])



    const getTest = async (filter) => {   
        var call = filter;
        
        //console.log("CALL");
        //console.log(call);
        var url = '/api/dashboard/CommonFormatSubmissionSummary';
        
        return http.post(url, call,{
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }


    


    const getListCols = (selectedList, sortingInfo)=>{
        const listColumns = [];

        const title = function ({rowName}) {
            //TestTitle {0} test {1}
            //Params: rowName, "valuehere"
            return "Click the link to edit user " + rowName + ".";
        }

        const orgNameTitle = function ({rowName}) {
            //TestTitle {0} test {1}
            //Params: rowName, "valuehere"
            return rowName.psoName;
        }

        const fullNameTitle = function ({rowName}) {
            //console.log(rowName);
            return "Click the link to view user " + rowName + ".";
        }

        const userState = function ({rowName}) {
           
            return {
                groupId: rowName.groupId, 
                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        filter
                    },
                    
                }
            };
        }

        const updateState = function ({rowName}) {
           
            return {
                groupId: rowName.groupId, 
                docId: rowName.docId, 
                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        filter
                    },
                    
                }
            };
        }

        const viewState = function ({rowName}) {
           
            return {
                docId: rowName.docId, 
                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        filter
                    },
                    
                }
            };
        }

        
        

        listColumns.push(Datatable_Column({
            name:"PSO ID", 
            columnName:"psoId", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"PSO Name", 
            columnName:"psoName", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"Type", 
            columnName:"type", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"CF Version", 
            columnName:"cfVersion", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"Last Submission Date", 
            columnName:"lastSubmissionDate", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo,
            formatFunction: formatDate
        }))
        listColumns.push(Datatable_Column({
            name:"No. of Rpts", 
            columnName:"numOfFiles", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"No. of Rpts Replacing Prev. CF Ver.", 
            columnName:"sameVersionResubmit", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"No. of Rpts Replaced in Later CF Ver.", 
            columnName:"crossVersionResubmit", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
       
        

        return listColumns;
      }

      const tableTitle = function () {
        return "PSO Common Formats Submission Summary";
      }
      
      const tableDescription = function() {
        return null;
      }
      const [selectedCount, setSelectedCount] = useState(0);


    

  return (
    <>
       
        { filter!=null ?
            <DatatableBase 

                tableClassName="psoCFSubSumTable" 
                getData={getTest} 
                uniqueId="psoCFSubSumTable"
                
                filter = {filter}
                setFilter={setFilter}

                getListCols={getListCols} 
                setSelectedCount={setSelectedCount} 
                hasSelectableRows={false} 
                searchFieldText={"Search by PSO ID, PSO Name, Type, or CF Version"} 
                
                datatableHeader={tableTitle()} 
                datatableDescription={tableDescription()}
                sortingColumn={sortColumn.sortField} 
                sortingOrder={sortColumn.sortDirection}
            >
                    
               
            
            </DatatableBase>
            :null
        }  
    </>
  );
}

export default PSOCFSubmissionSummaryTable;